// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._component-side-helper-mobile[data-v-69a2b5af] {\n  display: none;\n  width: 72px;\n}\n._component-side-helper-mobile .trigger-wrap[data-v-69a2b5af] {\n  width: 72px;\n}\n._component-side-helper-mobile .bar-pop[data-v-69a2b5af] {\n  position: absolute;\n  z-index: 90;\n  bottom: calc(100% + 10px);\n  right: 0;\n}\n@media screen and (max-width: 1190px) {\n._component-side-helper-mobile[data-v-69a2b5af] {\n    display: block;\n}\n}\n", ""]);
// Exports
module.exports = exports;
